import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';

const CssBox = styled(Box)(({ theme }) => ({
   backgroundColor: theme.palette.primary.main,
})
);
export default CssBox;